import SignInTemplate from "../../templates/SignInTemplate/SignInTemplate";

const SignIn = () => {
  return <SignInTemplate />;
};
export default SignIn;
